<template>
  <div style="height:100%">
    <div class="mapArea">
      <header>
        <h1><img class="topImage" src="/img/h1.png"   srcset="/img/h1@2x.png 2x" alt="北海道美瑛町×東京カメラ部 美瑛町観光スポット -Sightseeing Spots in Biei, Hokkaido-"/></h1>
      </header>
      <GmapMap
        :center="center"
        :zoom="zoom"
        :options="options"
        ref="map"
        style="width: 100%; height: 86%; position: absolute;"
      >
        <GmapCluster
            :gridSize="36"
            :zoomOnClick="true"
            :minimumClusterSize="2"
            :styles="clusterStyles"
            ref="cluster"
        >
          <GmapMarker
            v-for="(marker, index) in markers"
            :key="index"
            :position="marker.position"
            :clickable="true"
            :draggable="false"
            :icon="marker.icon"
            @mouseover="marker.openInfoWindow=true"
            @mouseout="marker.openInfoWindow=false"
            @click="openModal(marker.work)"
          >
            <GmapInfoWindow
              :options="{maxWidth: 300, disableAutoPan: true}"
              :opened="marker.openInfoWindow"
            >
              <img :src="marker.imageUrl" style="maxWidth: 200px; margin-left:2px">
            </GmapInfoWindow>
          </GmapMarker>
        </GmapCluster>
      </GmapMap>
    </div><!-- /mapArea-->
    <div class="bottomBlock">

      <section id="topMessage">
          <div class="inner">
            <h2>美瑛町の観光スポットをご紹介しています</h2>
          </div><!-- /inner-->
      </section><!-- /topMessage-->

      <section id="thumbnailMenu">
        <div class="inner">
          <button type="button" class="left" id="prevArrow"><img class="slickBtn" src="/img/btn_left.png" srcset="/img/btn_left@2x.png 2x" alt="左へ" /></button>
          <div class="thumbnailList">
            <slick
              ref="slick"
              :options="slickOptions"
              v-if="works!=null"
            >
              <div v-for="(work) in works" :key="work.id" @click="openModal(work)"><div class="thumbnaiImg fade" :style="`background-image: url(${work.thumbnailUrl});`"></div></div>
            </slick>
          </div>
          <button type="button" class="right" id="nextArrow"><img class="slickBtn" src="/img/btn_right.png" srcset="/img/btn_right@2x.png 2x" alt="右へ" /></button>
        </div><!-- /inner-->
      </section><!-- /thumbnailMenu-->

      <footer>
        <nav id="footerMenu">
          Supported by <a target="_blank" href="https://www.biei-hokkaido.jp/ja/">美瑛町観光協会</a> ｜ <a target="_blank" href="https://mybiei.jp/">丘のまちびえいＤＭＯ</a> ｜ <a target="_blank" href="http://town.biei.hokkaido.jp/">美瑛町</a>
        </nav><!-- /footerMenu -->
        <div id="footerCopy">
          <a target="_blank" href="https://corporate.tokyocameraclub.com/"><img class="footLogo" src="/img/foot_tccLogo.png" srcset="/img/foot_tccLogo@2x.png 2x" alt="東京カメラ部" /></a>
          <div id="copyright">Copyright © Tokyo Camera Club Corp. All Rights Reserved.</div><!-- #copyright -->
        </div><!-- /footerCopy -->
      </footer>

      <!-- スポット詳細のモーダルウィンドウ -->
      <SpotModal
        :open.sync="spotModal"
        :work.sync="modalWork"
      ></SpotModal>

    </div><!-- /bottomBlock-->
  </div>
</template>

<script>
import { Me } from '@/api'
import SpotModal from '@/views/components/SpotModal.vue'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import Slick from 'vue-slick'
import '../../node_modules/slick-carousel/slick/slick.css'

export default {
  components: {
    Slick,
    SpotModal,
    GmapCluster
  },
  data () {
    return {
      // 作品
      works: null,
      // GoogleMap関連データ
      center: { lat: 43.5880947, lng: 142.4647807 },
      zoom: 10,
      options: {
        clickableIcons: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        styles: [
          {
            featureType: 'all',
            elementType: 'all',
            stylers: [
              { saturation: -60 }
            ]
          }
        ]
      },
      markers: [],
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false
      },
      clusterStyles: [
        {
          textColor: 'white',
          url: '/img/googlemap/m1.png',
          height: 74,
          width: 72,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m2.png',
          height: 77,
          width: 74,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m3.png',
          height: 87,
          width: 84,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m4.png',
          height: 99,
          width: 96,
          anchorText: [0, 1]
        },
        {
          textColor: 'white',
          url: '/img/googlemap/m5.png',
          height: 111,
          width: 109,
          anchorText: [0, 1]
        }
      ],
      // サムネイル関連
      slickOptions: {
        arrows: true,
        dots: false,
        infinite: false,
        swipeToSlide: true,
        speed: 300,
        slidesToShow: 12,
        slidesToScroll: 1,
        prevArrow: '#prevArrow',
        nextArrow: '#nextArrow',
        responsive: [
          {
            breakpoint: 1600,
            settings: { slidesToShow: 10 }
          },
          {
            breakpoint: 1400,
            settings: { slidesToShow: 8 }
          },
          {
            breakpoint: 1200,
            settings: { slidesToShow: 6 }
          },
          {
            breakpoint: 580,
            settings: { slidesToShow: 5 }
          },
          {
            breakpoint: 520,
            settings: { slidesToShow: 4 }
          },
          {
            breakpoint: 460,
            settings: { slidesToShow: 3 }
          },
          {
            breakpoint: 360,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 360,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 280,
            settings: { slidesToShow: 1 }
          }
        ]
      },
      // モーダル関連
      modalWork: null,
      spotModal: false
    }
  },
  async created () {
    // APIデータの取得
    await Me.getUserWorks()
      .then(async response => {
        // 変数に格納
        this.works = response.data
        // 国名はいらないので「日本、」という文字列を削除
        for (const work of this.works) { work.address = work.address.replace('日本、', '') }
      }).catch(() => {
      })
    await this.setMarker(this.works)
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    async setMarker (works) {
      // markerの初期化
      this.markers.splice(0)
      for (const work of works) {
        this.markers.push({
          position: { lat: parseFloat(work.latitude), lng: parseFloat(work.longitude) },
          work: work,
          openInfoWindow: false,
          imageUrl: work.thumbnailUrl,
          icon: { url: '/img/icon_photo_s.png' }
        })
      }
      // 中心・倍率・表示範囲の計算
      let minX = this.markers[0].position.lng
      let maxX = this.markers[0].position.lng
      let minY = this.markers[0].position.lat
      let maxY = this.markers[0].position.lat
      for (const marker of this.markers) {
        if (marker.position.lng <= minX) { minX = marker.position.lng }
        if (marker.position.lng > maxX) { maxX = marker.position.lng }
        if (marker.position.lat <= minY) { minY = marker.position.lat }
        if (marker.position.lat > maxY) { maxY = marker.position.lat }
      }
      this.$gmapApiPromiseLazy().then(async () => {
        const sw = new window.google.maps.LatLng(maxY, minX)
        const ne = new window.google.maps.LatLng(minY, maxX)
        const bounds = new window.google.maps.LatLngBounds(sw, ne)
        const map = await this.$refs.map.$mapPromise
        map.fitBounds(bounds)
      })
    },
    openModal (work) {
      this.$ga.event('SpotModal', 'click', `work_${work.id}`, null)
      this.modalWork = work
      this.spotModal = true
    }
  }
}
</script>

<style>
.gm-ui-hover-effect {
  display: none !important;
}
.slick-disabled {
  pointer-events: none;
  opacity:0.2;
}
.slickBtn:hover {
  opacity: 0.5;
}
@media screen and (max-width:640px){
  .slickBtn:hover {
    opacity: 1.0;
  }
  .slickBtn:active {
    opacity: 1.5;
  }
}
</style>
